module.exports = __webpack_public_path__ + "img/circle-loading.4baf1107.svg";